<template>
  <div>
    <!--<bread-crumb2 :menu="{name: '배송 가능 시간 설정'}"></bread-crumb2>-->
    <div class="column is-10" v-if="this.$store.getters.mode!=='partner'">
      <div class="box">
        <admin-box-item title="파트너 선택">
          <lp-adm-drop-input
            @onSelect="selectPartner"
            :data.sync="partner_list"
            width="160px"
            listAlign="center"></lp-adm-drop-input>
        </admin-box-item>
      </div>
    </div>
    <div class="column is-10" v-if="partner_id">
      <div class="box">
        <admin-box-item title="배송 날짜 선택">
          <schedule-calendar ref="calendar"
                             :partner_id="partner_id"
                             :operatingTime="partner.company_operating"></schedule-calendar>
        </admin-box-item>
      </div>
    </div>
  </div>
</template>

<script>
  import ScheduleCalendar from "../partner/component/ScheduleCalendar";
  import BreadCrumb2 from "../../module/common/BreadCrumb2";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";

  export default {
    name: "PartnerDeliveryTimeSetting",
    components: {LpAdmDropInput, BreadCrumb2, ScheduleCalendar},
    data() {
      return {
        partner: undefined,
        partner_id: 0,
        partner_list: [] // 선택할 파트너 목록
      }
    },
    created() {
      if (this.$store.getters.mode === 'partner') {
        this.partner_id = this.$store.getters.partner.partner_id;
        this.getPartner();
      }
      else {
        this.getPartnerSimple();
      }
    },
    methods: {
      selectPartner (res) {
        this.partner_id = res.value;
        this.getPartner();
      },
      getPartnerSimple () {
        let url = this.getUrl('partner/simple');
        this.$axios.get(url).then(res => {
          this.partner_list = res.data;
        })
      },
      getPartner () {
        this.$axios.get(this.getUrl(`partner/${this.partner_id}`)).then(res => {
          this.partner = res.data.partner;
        });
      }
    }
  }
</script>

<style scoped>

</style>
